export const ROUTES = {
    ROOT: "/",
    BOARD: "/",
    LEARNING_JOURNEY: "/t/:id",
    LEARNING_JOURNEY_PLAN: "/t/:id/plan",
    LEARNING_JOURNEY_STEP: "/t/:id/step/:stepId",
    ACCOUNT: {
        BASE: "/account",
        SIGNUP: "/account/signup",
        LOGIN: "/account/login",
        VERIFY_EMAIL: "/account/verify-email/:key",
        PASSWORD_RESET: "/account/password/reset",
        PASSWORD_RESET_KEY: "/account/password/reset/key/:key",
        PROVIDER_CALLBACK: "/account/provider/callback",
    },
};
